module.exports = __webpack_public_path__ + "img/cartao_amex.82d59992.png";